import { Menu as MenuIcon, Search as SearchIcon } from '@mui/icons-material';
import { AppBar, Box, IconButton, Slide, Toolbar } from '@mui/material';
import { styled } from '@mui/system';
import { useState } from 'react';
import { ReactComponent as RwLogo } from '../../../../assets/logo-small.svg';
import { SearchBar } from './search-bar/search-bar';
import TopNavMenuMobile from './top-nav-menu-mobile';

const LogoBox = styled(Box)({
  marginLeft: 8
});

const ActionMenuButton = styled(IconButton)(({ theme }) => ({
  width: 48,
  height: 48,
  margin: '11px 0 11px 18px',
  borderRadius: 24,
  color: '#fff',
  '& svg': {
    fontSize: '26px !important'
  },
  '&:hover': {
    backgroundColor: '#265D7C'
  },
  '&:focus-visible': {
    border: '2px solid #1EB9FB'
  },
  '&.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-colorInherit.MuiIconButton-sizeMedium': {
    backgroundColor: '#032F40',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#032F40'
    }
  }
}));

export const TopNavMobile = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <>
      <AppBar position="relative" sx={{ backgroundColor: 'nav.main', height: 56 }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <LogoBox>
            <RwLogo />
          </LogoBox>

          <Box display="flex" alignItems="center">
            <ActionMenuButton onClick={() => setIsSearchOpen(true)}>
              <SearchIcon />
            </ActionMenuButton>
            <ActionMenuButton
              onClick={() => {
                setIsVisible((d) => !d);
              }}
            >
              <MenuIcon />
            </ActionMenuButton>
          </Box>
        </Toolbar>
        <SearchBar visible={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
      </AppBar>
      <Slide direction="down" in={isVisible} mountOnEnter exit onExited={() => setIsVisible(false)}>
        <TopNavMenuMobile onClose={() => setIsVisible(false)} />
      </Slide>
    </>
  );
};
